<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item :to="{ path: '/order_list' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="info-wrapper">
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-form ref="form" disabled :model="order" label-width="100px">
            <el-form-item label="订单号">
              <el-input v-model="order.orderNo"></el-input>
            </el-form-item>
            <el-form-item label="订单数量">
              <el-input v-model="order.totalNum"></el-input>
            </el-form-item>
            <el-form-item label="下单学校">
              <el-input v-model="order.schoolName"></el-input>
            </el-form-item>
            <el-form-item label="最后操作人">
              <el-input v-model="order.entryUserName"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-form ref="form" disabled :model="order" label-width="100px">
            <el-form-item label="订单状态">
              <el-input v-model="order.statusDesc"></el-input>
            </el-form-item>
            <el-form-item label="订单总价(元)">
              <el-input v-model="order.totalAmt"></el-input>
            </el-form-item>
            <el-form-item label="下单用户">
              <el-input v-model="order.userName"></el-input>
            </el-form-item>
            <el-form-item label="最后操作时间">
              <el-input v-model="order.entryTime"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :span="8" style="padding-left: 0">
        <div class="grid-content">
          <el-form ref="form" disabled :model="order" label-width="120px">
            <el-form-item label="订单时间">
              <el-input v-model="order.createTime"></el-input>
            </el-form-item>
            <el-form-item label="付款方式">
              <el-input v-model="order.tradeTypeDesc"></el-input>
            </el-form-item>
            <el-form-item label="购买用户证件号">
              <el-input v-model="order.userNo"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-table
      class="table"
      :data="courseList"
    >
      <el-table-column
        prop="courseId"
        label="课程编号"
        align="center"
        width="80">
      </el-table-column>
      <el-table-column
        prop="name"
        label="课程名称"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="price"
        label="课程价格(元)"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="count"
        label="课程数量"
        align="center"
        width="100">
      </el-table-column>
    </el-table>
    <div class="info-title" v-if="order.status===4 || order.status===5">发货信息</div>
    <el-row :gutter="10" class="info-wrapper" v-if="order.status===4 || order.status===5">
      <el-col :span="13">
        <el-form ref="form" disabled label-width="100px">
          <el-form-item label="收件地址">
            <el-input v-model="addressStr"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <el-button
            type="primary"
            v-clipboard:copy="addressStr"
            v-clipboard:success="_copyAddress"
            v-clipboard:error="_copyError"
          >复制</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="express-wrapper" v-if="order.status===4">
      <el-col :span="4" style="padding-left: 0">
        <div class="grid-content">
          <el-select v-model="expressCompany" clearable placeholder="快递公司">
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="1">&nbsp;</el-col>
      <el-col :span="6" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="expressNo">
            <template slot="prepend">快递单号</template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top: 20px;" v-if="order.status===2 || order.status===4">
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="5" style="padding-left: 0">
        <div class="grid-content">
          <el-button type="default" @click="cancel" :loading="loading">取消</el-button>
        </div>
      </el-col>
      <el-col :span="3" style="padding-left: 0">
        <div class="grid-content">
          <el-button type="primary" @click="_orderConfirm" v-if="order.status===2" :loading="loading">确认到账</el-button>
          <el-button type="primary" @click="_orderExpress" v-if="order.status===4" :loading="loading">发货</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="info-wrapper" v-if="order.status===5">
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递公司">
            <el-input v-model="expressInfo.expressCoDesc"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="快递单号">
            <el-input v-model="expressInfo.expressNo"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="8">
        <el-form ref="form" disabled :model="expressInfo" label-width="100px">
          <el-form-item label="发货时间">
            <el-input v-model="expressInfo.entryTime"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import { getOrderDetail, orderConfirm, orderExpress } from '@/api/order';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        order: {},
        courseList: [],
        expressInfo: null,
        companyOptions: [{
          value: 'sf',
          label: '顺丰'
        }, {
          value: 'db',
          label: '德邦'
        }, {
          value: 'yt',
          label: '圆通'
        }],
        expressCompany: '',
        expressNo: '',
        addressStr: '',
        loading: false
      };
    },
    created() {
      this._getOrderDetail();
    },
    methods: {
      _getOrderDetail() {
        getOrderDetail(this.user.userId, this.$route.params.id).then((res) => {
          const { orderInfo, orderDetails, expressInfo, addressStr } = res;
          this.order = orderInfo;
          this.courseList = orderDetails;
          this.expressInfo = expressInfo;
          this.addressStr = addressStr;
        });
      },
      _copyAddress() {
        this.$message.success('复制成功');
      },
      _copyError() {
        this.$message.error('复制失败');
      },
      _orderConfirm() {
        this.loading = true;
        orderConfirm(this.user.userId, this.$route.params.id).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            const { orderInfo, addressStr } = res;
            this.order = orderInfo;
            this.addressStr = addressStr;
          } else {
            this.$message.error('审核失败');
          }
        }).catch(() => {
          this.loading = false;
        });
      },
      _orderExpress() {
        if (!this.expressCompany) {
          this.$message.warning('请选择快递公司');
          return;
        }
        if (!this.expressNo) {
          this.$message.warning('请输入快递号');
          return;
        }
        this.loading = true;
        orderExpress(this.user.userId, this.$route.params.id, this.expressCompany, this.expressNo).then((res) => {
          this.loading = false;
          if (res.rspCode === 0) {
            const { orderInfo, expressInfo } = res;
            this.order = orderInfo;
            this.expressInfo = expressInfo;
          } else {
            this.$message.error('发货失败');
          }
        }).catch(() => {
          this.loading = false;
        });
      },
      cancel() {
        this.$router.back(-1);
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    .title
      margin-bottom: 20px;
    .info-title
      margin-top: 20px;
      margin-bottom: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #606266;
      cursor: text;
    .info-wrapper
      padding: 20px 20px 0 0;
      margin: 0 0 10px 0 !important;
      background: #fff;
    .express-wrapper
      padding: 20px;
      background: #fff;
</style>